import { RequestStatus } from "../../../../Enums/RequestStatus";

export const ReasoningEvidenceListTitle = "Reasoning Evidence List";

export const QuarantineStageListTitle = "Quarantine Stage List";

export const WoWaitingListTitle = "Wo Waiting List";

export const RepairProcessDoneListTitle = "Repair Process Will Done";

export const InitialReceivingListTitle = "Initial Receiving List";

export const ManuelCoverageControlListTitle = "Manuel Coverage Control";

export const WWVendorProcessListTitle = "Warranty/Workscope/Vendor Process";

export const CustomsClearanceListTitle = "Custom Clearance List";

export const SourceRequestOrder = "requestorders";

export const SourcePbhRequestOrder = "pbhrequestorders";

export const SourceEightWings = "eightwings";

export const SourceCdmHeader = "cdmheaders";

export const SourceCdmPoolPn = "cdmpoolpns";

export const SourceCdmAircrafts = "cdmpoolpns";

export const SourceCdmSystemTransactionMels = "cdmsystemtransactionmels";

export const TitleRequestOrder = {
  list: "Request Order List",
  edit: "Edit Company",
  create: "Create Company",
};

export const OpenNotSetGroup: RequestStatus[] = [
  RequestStatus.Created,
  RequestStatus.NotPool,
  RequestStatus.DocumentZeroValue,
  RequestStatus.NoCapability,
];

export const InProgressGroup: RequestStatus[] = [
  RequestStatus.Pool,
  RequestStatus.SendShippingDetails,
  RequestStatus.PlaneLanded,
  RequestStatus.ReplacementPnOffered,
  RequestStatus.ReplacementPnAccepted,
  RequestStatus.ReplacementPnRejected,
  RequestStatus.RequestRedeliveryOffered,
  RequestStatus.RequestRedeliveryAccepted,
  RequestStatus.RequestRedeliveryRejected,
];

export const RejectedGroup: RequestStatus[] = [RequestStatus.NotPlmsStatus, RequestStatus.PoolUserAccept];

export const WaitingTTApprovalGroup: RequestStatus[] = [RequestStatus.PoolUserReject];
